var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMarketGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ehkf67oeygm1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 91.408514,
    height: 280,
    rx: 0,
    ry: 0,
    transform: "matrix(1.203389 0 0 0.716887 40 311.27164)",
    fill: "#72788b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 91.408514,
    height: 280,
    rx: 0,
    ry: 0,
    transform: "matrix(1.203389 0 0 0.480615 40 311.27164)",
    fill: "#b2b2b8",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.000001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.408514,
    height: 280,
    rx: 0,
    ry: 0,
    transform: "matrix(1.203389 0 0 1.588035 200 67.3502)",
    fill: "#72788b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 91.408514,
    height: 280,
    rx: 0,
    ry: 0,
    transform: "matrix(1.203389 0 0 0.93456 200 67.3502)",
    fill: "#b2b2b8",
    strokeWidth: 0
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.000001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.408514,
    height: 280,
    rx: 0,
    ry: 0,
    transform: "matrix(1.203389 0 0 1.042004 360 220.23888)",
    fill: "#72788b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 91.408514,
    height: 280,
    rx: 0,
    ry: 0,
    transform: "matrix(1.203389 0 0 0.653478 360 220.23888)",
    fill: "#b2b2b8",
    strokeWidth: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketGray);
export default __webpack_public_path__ + "static/media/icon-market-gray.6c87c1e63f17eb57661a263e12802b6c.svg";
export { ForwardRef as ReactComponent };